<div
  class="fade modal-lg modal"
  id="foodListModal"
  tabindex="-1"
  aria-labelledby="foodListModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header w-100 d-flex justify-content-between">
        <div class="d-flex">
          <h1 class="modal-title fs-5">Listado de comidas</h1>

          <button class="ms-3 btn-custom" (click)="openFoodFormModal()">
            Crear Nueva Comida
          </button>
        </div>

        <div class="">
          <button
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
      </div>

      <div class="modal-body" *ngIf="user">
        <table class="table table-hover" *ngIf="foods">
          <thead>
            <tr>
              <th scope="col">Nombre</th>
              <th scope="col">Proteínas</th>
              <th scope="col">Carbohidratos</th>
              <th scope="col">Grasas Totales</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr (click)="selectFood(food, $event)" *ngFor="let food of foods">
              <td>{{ food.name }}</td>
              <td>
                {{ food.proteins }}
              </td>
              <td>
                {{ food.carbohydrates }}
              </td>
              <td>
                {{ food.totalFats | number : "1.1-1" }}
              </td>
              <td>
                <i
                  class="bi bi-pencil-square me-2"
                  style="font-size: 20px; cursor: pointer"
                  (click)="selectFood(food, $event)"
                ></i>
                <i
                  class="bi bi-trash me-2"
                  (click)="deleteFood(food, $event)"
                  style="font-size: 24px; color: #dc3545; cursor: pointer"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
